module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-800.926d4d12.svg";